<template>
    <a-modal
            :title="title"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @cancel="$emit('close')"
            @ok="handleSubmit"
            destroyOnClose
    >
        <a-form
                :form="form"
                v-bind="formItemLayout"
                v-if="visible"
        >   
            <a-form-item label="激活码批号">
                <a-input v-decorator="['spec', { rules: [{ required: true, message: '请输入生成的激活码批次!' }] }]" placeholder="请输入生成激活码批次" />
            </a-form-item>
            <a-form-item label="激活码前缀">
                <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入生成激活码前缀!' }] }]" placeholder="请输入生成激活码前缀" />
            </a-form-item>
            <a-form-item label="激活码数量">
                <a-input v-decorator="['number', { rules: [{ required: true, message: '请输入生成激活码数量!' }] }]" placeholder="请输入生成激活码数量" />
            </a-form-item>
            <!-- 动态多个可兑换项 -->
            <div>
                <div v-for="(item, idx) in items" :key="idx" style="border:1px dashed #e5e5e5;padding:12px 12px 0;margin-bottom:12px;border-radius:6px;">
                    <a-form-item label="类型">
                        <a-select v-model="item.type" placeholder="请选择类型" @change="val=>onTypeChange(idx, val)">
                            <a-select-option :value="opt.id" v-for="(opt,i) in options" :key="i">{{opt.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="学科">
                        <a-select v-model="item.cate_id" placeholder="请选择学科" @change="val=>onSubjectChange(idx, val)">
                            <a-select-option :value="s.cate_id" v-for="(s,i) in data" :key="i">{{s.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <!-- 绑定内容：当类型为电子真题(type=1)时，选择可兑换的真题试卷，支持多选 -->
                    <a-form-item label="绑定试卷" v-if="item.type === 1">
                        <a-select 
                          mode="multiple" 
                          :allowClear="true"
                          :disabled="!item.bindingOptions.length"
                          placeholder="请选择可兑换试卷（可多选）"
                          v-model="item.bind_ids"
                          style="width: 100%"
                        >
                            <a-select-option v-for="bp in item.bindingOptions" :key="bp.id" :value="bp.id">{{ bp.title || bp.name || bp.cname }}</a-select-option>
                        </a-select>
                        <div v-if="!item.bindingOptions.length" style="color:#999;margin-top:6px;">请先选择类型与学科，以加载试卷列表</div>
                    </a-form-item>
                    <div style="text-align:right;margin-bottom:12px;">
                        <a-button type="link" @click="removeItem(idx)" v-if="items.length>1">移除该兑换项</a-button>
                    </div>
                </div>
                <a-button type="dashed" block @click="addItem">添加一个可兑换项</a-button>
            </div>
            
        </a-form>
    </a-modal>
</template>
<script>
    import { uploadImg } from '@/libs/api'
    import * as http from '@/libs/analysis'
    export default {
        name: 'addActive',
        props: [ 'visible', 'data' ],
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        watch:{
            visible(val){
                if(val){
                    if(this.data){
                        this.title = "编辑激活码"
                    }else{
                        this.title = "新增激活码";
                    }
                    // 每次打开，初始化一个兑换项
                    this.$nextTick(() => {
                      if(!this.items.length){
                        this.addItem();
                      }
                    })
                }
            }
        },
        data(){
            return{
                confirmLoading: false,
                loading: false,
                id: 1,
                title: '',
                spec:'',
                name:'',
                days:'',
                number:'',
                formItemLayout: {
                    labelCol: { span: 5 },
                    wrapperCol: { span: 18 },
                },
                // 新的产品类型（激活码类型）
                options :[
                    { name: '电子真题', id: 1 },
                    { name: '真题笔记', id: 2 },
                    { name: '会员题库', id: 3 },
                    { name: '冲刺题库', id: 4 },
                    { name: '课程精讲', id: 5 },
                    { name: '打印资料', id: 6 }
                ],
                // 多个可兑换项
                items: []
            }
        },
        methods:{
            addItem(){
                this.items.push({ type: null, cate_id: null, bind_ids: [], bindingOptions: [] });
            },
            removeItem(idx){
                this.items.splice(idx, 1);
            },
            onTypeChange(idx, val){
                const it = this.items[idx];
                it.type = val;
                it.bind_ids = [];
                it.bindingOptions = [];
                this.loadBindingOptions(idx);
            },
            onSubjectChange(idx, val){
                const it = this.items[idx];
                it.cate_id = val;
                this.loadBindingOptions(idx);
            },
            async loadBindingOptions(idx){
                const it = this.items[idx];
                if(it && it.type === 1 && it.cate_id){
                    try{
                        const res = await http.openCourseTaskList({ cate_id: it.cate_id, type: 1 });
                        const list = res.list || res || [];
                        it.bindingOptions = Array.isArray(list) ? list : [];
                    }catch(e){
                        console.log('加载试卷失败', e);
                        it.bindingOptions = [];
                    }
                }else{
                    it.bindingOptions = [];
                }
            },
            handleSubmit(){
                // 校验可兑换项
                if(!this.items.length){
                    this.$message.error('请至少添加一个可兑换项');
                    return;
                }
                const invalid = this.items.some(it => !it.type || !it.cate_id || (it.type === 1 && (!it.bind_ids || !it.bind_ids.length)));
                if(invalid){
                    this.$message.error('请完善每个兑换项的类型、学科及绑定内容');
                    return;
                }
                this.form.validateFields((err, values) => {
                    if(err) return;
                    this.confirmLoading = true
                    const payloadItems = this.items.map(it => ({
                        type: it.type,
                        cate_id: it.cate_id,
                        bind_ids: Array.isArray(it.bind_ids) ? it.bind_ids.join(',') : (it.bind_ids || '')
                    }));
                    const payload = { ...values, items: JSON.stringify(payloadItems) };
                    if(payloadItems.length === 1){
                        payload.type = payloadItems[0].type;
                        payload.cate_id = payloadItems[0].cate_id;
                        payload.bind_ids = payloadItems[0].bind_ids;
                    }
                    http.create_active(payload).then(res=>{
                        this.$emit('close')
                        this.$emit('update')
                        this.confirmLoading = false
                    }).catch((error)=>{
                        console.log(error)
                        this.confirmLoading = false
                    })
                });
            },
            beforeUpload(){

            },
            customRequest(data){
                let formData = new FormData()
                formData.append('file',data.file)
                uploadImg(formData).then(res=>{
                    if(res){
                        this.imageUrl=res.fileUrl
                    }
                },error=>{
                    console.log(error)
                })
            },
            handleChange(){

            }
        }
    }
</script>